import React, { useState } from 'react';
import axios from 'axios';
import AuthFormContainer from './AuthFormContainer';
import AuthInput from './AuthInput';

function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [userToken, setUserToken] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post('/api/auth/user-login', {
        email,
        user_token: userToken
      });

      if (response.data.success) {
        const { token, user } = response.data;
        localStorage.setItem('timeLockToken', token);
        localStorage.setItem('timeLockUser', JSON.stringify(user));
        onLogin(user);
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthFormContainer
      title="TimeLock"
      subtitle="Login to your account"
      error={error}
      loading={loading}
      onSubmit={handleSubmit}
      buttonText="Login"
      footerText={
        <>
          You received your access token via email.<br/>
          <span className="text-slate-500">Don't have one? Contact support.</span>
        </>
      }
    >
      <AuthInput
        label="Email"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="your@email.com"
      />
      <AuthInput
        label="Access Token"
        type="password"
        value={userToken}
        onChange={(e) => setUserToken(e.target.value)}
        placeholder="Enter your access token"
        isMono={true}
      />
    </AuthFormContainer>
  );
}

export default Login;
